import { campaignBuilderRoutePathsMap } from '@shared/router/routePaths.ts';
import { CampaignId } from '@shared/types/campaign.ts';

export const getStepperActiveIndex = (pathname: string, campaignId: CampaignId | undefined) => {
  const currentStep = Object.keys(campaignBuilderRoutePathsMap).reduce(
    (acc, curr) => {
      if (!campaignId && campaignBuilderRoutePathsMap[curr].url() === pathname) {
        return campaignBuilderRoutePathsMap[curr];
      }
      if (campaignBuilderRoutePathsMap[curr].url(campaignId) === pathname) {
        return campaignBuilderRoutePathsMap[curr];
      }
      return acc;
    },
    { url: () => '/campaigns/builder/', activeStep: 0, routerPath: '' },
  );

  return currentStep.activeStep;
};

export const getUrlForStepIndex = (stepIndex: number, campaignId: CampaignId | undefined): string => {
  const stepMap: Record<number, string> = {
    0: campaignId ? campaignBuilderRoutePathsMap.step01.url(campaignId) : campaignBuilderRoutePathsMap.initialize.url(),
    1: campaignId ? campaignBuilderRoutePathsMap.step02.url(campaignId) : campaignBuilderRoutePathsMap.initialize.url(),
    2: campaignId ? campaignBuilderRoutePathsMap.step03.url(campaignId) : campaignBuilderRoutePathsMap.initialize.url(),
    3: campaignId ? campaignBuilderRoutePathsMap.step04.url(campaignId) : campaignBuilderRoutePathsMap.initialize.url(),
    4: campaignId ? campaignBuilderRoutePathsMap.step05.url(campaignId) : campaignBuilderRoutePathsMap.initialize.url(),
  };

  return stepMap[stepIndex] || campaignBuilderRoutePathsMap.initialize.url();
};
